"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _Icon = _interopRequireDefault(require("./Icon"));
var _CheckboxGroup = _interopRequireDefault(require("../hocs/CheckboxGroup"));
var _CheckboxController = _interopRequireDefault(require("../hocs/CheckboxController"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var checkboxType = /*#__PURE__*/function (checkboxType) {
  checkboxType["primary"] = "primary";
  checkboxType["success"] = "success";
  checkboxType["error"] = "error";
  checkboxType["warning"] = "warning";
  checkboxType["ghost"] = "ghost";
  return checkboxType;
}(checkboxType || {});
const propTypes = {
  type: _propTypes.default.oneOf(Object.values(checkboxType)),
  size: _propTypes.default.number,
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
const defaultProps = {
  type: checkboxType.primary,
  size: 22
};
function Checkbox(props) {
  const {
    size,
    checked
  } = props;
  const {
    colors
  } = (0, _react2.useTheme)();
  return /*#__PURE__*/_react.default.createElement(Container, props, checked && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "check",
    size: size - 8,
    color: colors.FONT.CONTRAST
  }));
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 5px;\n  overflow: hidden;\n  border-width: 1.5px;\n  display: grid;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  height: ", "px;\n  width: ", "px;\n\n  i {\n    cursor: pointer;\n  }\n\n  ", "\n\n  ", "\n"])), _ref => {
  let {
    size
  } = _ref;
  return size;
}, _ref2 => {
  let {
    size
  } = _ref2;
  return size;
}, _ref3 => {
  let {
    disabled
  } = _ref3;
  return disabled ? 'opacity: 0.5;' : '';
}, _ref4 => {
  var _colors$MAIN;
  let {
    type,
    theme,
    checked
  } = _ref4;
  const {
    colors
  } = theme;
  if (type === checkboxType.ghost) {
    if (checked) {
      return "\n          background: ".concat(colors.NEUTRAL.SELECTED, ";\n          border: 1px solid ").concat(colors.NEUTRAL.SELECTED, ";\n        ");
    }
    return "\n        background: ".concat(colors.FONT.CONTRAST, ";\n        border: 1px solid ").concat(colors.NEUTRAL.SELECTED, ";\n      ");
  }
  const mainColor = (_colors$MAIN = colors.MAIN) === null || _colors$MAIN === void 0 ? void 0 : _colors$MAIN[String(type).toUpperCase()];
  if (checked) {
    return "\n        background: ".concat(mainColor, ";\n        border: 1px solid ").concat(mainColor, ";\n      ");
  }
  return "\n      background: ".concat(colors.FONT.CONTRAST, ";\n      border: 1px solid ").concat(mainColor, ";\n    ");
});
Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
Checkbox.Group = _CheckboxGroup.default;
Checkbox.Controller = _CheckboxController.default;
var _default = exports.default = Checkbox;